import type { ReferenceToProperty, ViewConfigTreeNode } from '@salescore/core'

export type ReferenceToPropertyForAddChildNodeMutation = Omit<ReferenceToProperty, 'nodeName'> & {
  nodeName?: string
  parentNodeName: string
}

export const findSameReferenceToChild = (
  node: ViewConfigTreeNode,
  referenceToProperty: ReferenceToPropertyForAddChildNodeMutation,
): ViewConfigTreeNode | undefined => {
  if (referenceToProperty.parentNodeName !== node.name) return undefined

  return node.children?.find(
    (child) =>
      child.referenceToProperty !== undefined &&
      (referenceToProperty.nodeName === undefined
        ? // nodeNameが空のときは、これから生成する子ノード側にプロパティがあるということ。子ノード側にプロパティがあるのかを判定する
          child.name === child.referenceToProperty.nodeName
        : // nodeNameが存在するときは、生成済みの親ノードにプロパティがあるということ。親ノードの名前が一致するかを判定する
          node.name === child.referenceToProperty.nodeName && node.name === referenceToProperty.nodeName) &&
      referenceToProperty.modelName === child.referenceToProperty.modelName &&
      referenceToProperty.propertyName === child.referenceToProperty.propertyName &&
      referenceToProperty.referenceTo.modelName === child.referenceToProperty.referenceTo.modelName &&
      referenceToProperty.referenceTo.key === child.referenceToProperty.referenceTo.key,
  )
}
